import React, { useCallback } from 'react'
import { createContext, useState } from 'react'

export type ErrorType = {
    message: string
    description: string
}

type ErrorNotificationsProps = {
    children: JSX.Element
}

type ErrorNotificationsContextType = {
    errors: ErrorType[]
    addErrors: (e: ErrorType) => void
}

export const ErrorNotificationsContext = createContext<ErrorNotificationsContextType>({
    errors: [],
    addErrors: () => {},
})

const ErrorNotificationsProvider: React.FC<ErrorNotificationsProps> = ({ children }) => {
    const [errors, updateErrors] = useState<ErrorType[]>([])

    const addErrors = useCallback((error: ErrorType) => {
        updateErrors(prev => [
            ...prev,
            {
                ...error,
            },
        ])
    }, [])

    return (
        <ErrorNotificationsContext.Provider value={{ errors, addErrors }}>
            {children}
        </ErrorNotificationsContext.Provider>
    )
}

export default ErrorNotificationsProvider
